module.exports = __webpack_public_path__ + "static/media/caerus.58d72e88.jpg";